import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { BasicLayoutComponent } from './basicLayout.component';
import { BlankLayoutComponent } from './blankLayout.component';

import { NavigationComponent } from './../navigation/navigation.component';
import { FooterComponent } from './../footer/footer.component';
import { TopNavbarComponent } from './../topnavbar/topnavbar.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule, RouterModule, FormsModule, BsDropdownModule, SharedModule],
    declarations: [FooterComponent, BasicLayoutComponent, BlankLayoutComponent, NavigationComponent, TopNavbarComponent, HomeComponent, LoginComponent],
    exports: [FooterComponent, BasicLayoutComponent, BlankLayoutComponent, NavigationComponent, TopNavbarComponent],
})
export class LayoutsModule {}
